import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from '@app/shared/services/currency/currency.service';

@Pipe({
  name: 'globalCurrency',
})
export class GlobalCurrencyPipe implements PipeTransform {
  constructor(private readonly currencyPipe: CurrencyPipe, private readonly currencyService: CurrencyService) {}

  public transform(value: any, digits = '1.2-2', currencyIsoCode?: string): string | null {
    const currencyName = typeof currencyIsoCode !== 'undefined' ? currencyIsoCode : this.currencyService.currencyName;
    return currencyName ? this.currencyPipe.transform(value, currencyName, 'symbol', digits) : '';
  }
}
